import React from 'react'

export default function Feedback() {
  return (
    <div>
      <h1>Im Feedback </h1>
    </div>
  )
}
